module.exports = __webpack_public_path__ + "img/dev-profile.c0488825.png";